 document.addEventListener("DOMContentLoaded", function() {
    var collapsibleHeaders = document.querySelectorAll('.collapsible-header');
    collapsibleHeaders.forEach(function(header) {
      header.addEventListener('click', function() {
        var content = this.nextElementSibling;
        var icon = this.querySelector('.toggle-icon');

        if (content.style.display === "none") {
          content.style.display = "block";
          icon.textContent = "-";
        } else {
          content.style.display = "none";
          icon.textContent = "+";
        }
      });
    });
  });